@use 'ui/styles/core-tokens' as core;

.tableSkeleton {
  display: grid;
  gap: 12px;
  margin-top: 24px;
}
